'use strict';

angular
	.module('bringgApp')
	.controller('OnBoardingController', function (
		$rootScope,
		$scope,
		ENV_CONFIGURATION,
		WindowCommunicationService,
		BRINGG_NOW_CHECKOUT_FLOW,
		$sce
	) {
		$scope.getO2MUrl = function () {
			var url = ENV_CONFIGURATION.bringg_now_url + 'welcome?usedAsIframe=true';

			return $sce.trustAsResourceUrl(url);
		};

		$scope.sendCredentials = function () {
			WindowCommunicationService.sendCredentials();
		};
	});
